export const SSK_OFFICIAL_LOGO = '/ssk-logo-256.webp';
export const SSK_OFFICIAL_LOGO_FALLBACK = 'https://wfbkgfotpzscjyaanzpx.supabase.co/storage/v1/object/public/profile_photos/SSK%20LOGO%20AI%20File%20pdf_page-0001.jpg';
export const SSK_BRAND_NAME = 'SSK Business Network';
